import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";

const COST_FIELDS = [
  { key: "cost_per_day", label: "Custo por dia", prefix: "€" },
  { key: "cost_per_hour", label: "Custo por hora", prefix: "€" },
  { key: "cost_per_delivery", label: "Custo por pedido", prefix: "€" },
  { key: "cost_per_km", label: "Custo por km", prefix: "€" },
  { key: "shipping_percent", label: "Percentagem do frete", suffix: "%" },
  { key: "min_per_delivery", label: "Minimo por pedido", prefix: "€" },
  { key: "min_per_day", label: "Minimo por dia", prefix: "€" },
];

export function CostEditForm({ deliverer, onSave, onClose }) {
  const [costs, setCosts] = useState({
    cost_per_day: deliverer.cost_per_day || 0,
    cost_per_hour: deliverer.cost_per_hour || 0,
    cost_per_delivery: deliverer.cost_per_delivery || 0,
    cost_per_km: deliverer.cost_per_km || 0,
    shipping_percent: deliverer.shipping_percent || 0,
    min_per_delivery: deliverer.min_per_delivery || 0,
    min_per_day: deliverer.min_per_day || 0,
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await onSave(costs);
    setLoading(false);
  };

  return (
    <>
      <DialogHeader>
        <DialogTitle className="text-xl">Configurar Custos - {deliverer.name}</DialogTitle>
      </DialogHeader>
      <form onSubmit={handleSubmit} className="space-y-3 mt-4">
        <div className="grid grid-cols-2 gap-3">
          {COST_FIELDS.map(f => (
            <div key={f.key} className="space-y-1">
              <Label className="text-xs text-muted-foreground">{f.label}</Label>
              <div className="relative">
                {f.prefix && <span className="absolute left-3 top-1/2 -translate-y-1/2 text-xs text-muted-foreground">{f.prefix}</span>}
                <Input
                  type="number"
                  step="0.01"
                  min="0"
                  value={costs[f.key]}
                  onChange={e => setCosts(p => ({ ...p, [f.key]: parseFloat(e.target.value) || 0 }))}
                  className={f.prefix ? "pl-7" : ""}
                  data-testid={`cost-${f.key}`}
                />
                {f.suffix && <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-muted-foreground">{f.suffix}</span>}
              </div>
            </div>
          ))}
        </div>
        <DialogFooter className="pt-2">
          <Button type="button" variant="secondary" onClick={onClose}>Cancelar</Button>
          <Button type="submit" disabled={loading} data-testid="save-costs-btn">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Salvar Custos"}
          </Button>
        </DialogFooter>
      </form>
    </>
  );
}
